import { TranslateImPACTLeadToOnboardingRequest } from 'features/integration/impact/page-translate-to-onboarding';
import { PrivateRouteProps } from 'navigation/router/components/routes/private-route';
import { PublicRouteProps } from 'navigation/router/components/routes/public-route';
import { IntegrationRoutes } from 'routes';

export const INTEGRATION_ROUTES: (
  | (PrivateRouteProps & { type: 'private' })
  | (PublicRouteProps & { type: 'public' })
)[] = [
  {
    type: 'public',
    path: IntegrationRoutes.IMPACT_LANDING_SIGNIN,
    component: TranslateImPACTLeadToOnboardingRequest,
    redirectPath: IntegrationRoutes.IMPACT_JOIN,
    redirectShouldPreserveSearchQuery: true
  }
];
